module.exports = __webpack_public_path__ + "static/HF_Raven_Final-f24706b7d0b7ce949c1b8c09e93417cb.png";